export const EMPLOYEE_PROPS = {
  axios: {
    type: [String, Object]
  },
  inputLength: {
    type: [Number, String],
    default: 2
  },
  keys: {
    type: Array
  },
  valueKey: {
    type: String,
  },
  formatParams: {
    type: Function,
  },
  warning: {
    type: Boolean,
    default: true
  },
  formatResult: {
    type: Function
  },
  message: {
    type: String,
    default: '搜索结果为空！'
  },
  source: {
    type: String,
    default: ''
  },
  multiple: {
    type: Boolean,
    default: false
  },
  filterOptionProp: {
    type: Object,
    default: () => ({})
  },
  url: String
}



// WEBPACK FOOTER //
// ./src/public/components/kye-employee/props/employee.js